export const CASEFILE_INTAKE_FORM_ID = 'aus-casefile-intake-form';

export const DU_CASEFILE_FIELD_NAME = 'duCasefileId';
export const LP_AUS_KEY_FIELD_NAME = 'lpAusKey';

export const DU_CASEFILE_ID_LENGTH = 10;

export const DRAWER_TITLE = 'Retrieve AUS Findings';
export const SUBMIT_BUTTON_LABEL = 'Retrieve Findings';

export const DU_FIELD_LABEL = 'Fannie Mae DU Casefile ID';
export const DU_FIELD_PLACEHOLDER = '10-digit casefile ID';
export const DU_ERROR_MESSAGE = 'Enter the 10-digit DU Casefile ID.';

export const LP_FIELD_LABEL = 'Freddie Mac LPA AUS Key';
export const LP_FIELD_PLACEHOLDER = 'AUS Key from the Feedback Certificate';

export const INFO_MESSAGE =
  'Enter one or both IDs from the broker. The casefile must already be assigned to your ' +
  'organization — Fannie Mae: the broker finalizes their DO submission to your sponsorship; ' +
  'Freddie Mac: the broker assigns the loan to your Seller/Servicer number in Loan Product Advisor.';

export const FOOTNOTE_MESSAGE =
  'Findings are retrieved under your company’s credentials. Legs without an ID are ' +
  'skipped — no new casefile is ever created for this loan.';

export const PREFILL_LABEL = 'From MISMO import';
export const PREFILL_NOTE = 'Detected in the file imported at registration.';
